// extracted by mini-css-extract-plugin
module.exports = {"meta":"MessageEntry__meta___8mDeW","message":"MessageEntry__message___1pX-6"};